import { render } from "./ChallengesPage.vue?vue&type=template&id=454974b5"
import script from "./ChallengesPage.vue?vue&type=script&lang=js"
export * from "./ChallengesPage.vue?vue&type=script&lang=js"
script.render = render

export default script